import Config from "../config/constants";
import axios, { AxiosResponse } from 'axios';

export const apiGetCollect= async (page: number, limit: number, accessToken: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/petcollect/list`;
    
    try {
        const response = await axios.get(url, {
            params: {
                page,
                limit        
            },headers: { access_token: accessToken }
        });
        return response.data; 
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; 
    }
};


export const apiDoCollect = async (params: any, accessToken: string): Promise<AxiosResponse> => {

    const url = `${Config.API_HOST}/api/admin/petcollect/docollect`;
    
    try {
        const response = await axios.post(url, params, {
            headers: { access_token: accessToken }
        });
        return response.data; 
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; 
    }
};

// Not useed now
export const apiUpdateCollect = async (params: any, id:number, accessToken: string): Promise<AxiosResponse> => {
    console.log("id=" + id);
    const url = `${Config.API_HOST}/api/admin/petcollect/${id}`;
    
    try {
        const response = await axios.patch(url, params, {
            headers: { access_token: accessToken }
        });
        return response.data; 
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; 
    }
};
    